var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-images"},[_c('img',{staticClass:"face",attrs:{"alt":"face image","src":require("../assets/face.png")}}),_c('img',{staticClass:"circles",attrs:{"alt":"circles image","src":require("../assets/circles.svg")}})])
}]

export { render, staticRenderFns }